import { Link } from "react-router-dom";
import type { Post } from "@/types/content";
import { categories } from "@/mocks/categories";

interface HotListProps {
  posts: Post[];
  limit?: number;
  title?: string;
}

export function categoryNameOf(slug: string) {
  return categories.find((c) => c.slug === slug)?.name ?? "综合";
}

export default function HotList({ posts, limit = 8, title = "实时热榜" }: HotListProps) {
  const list = posts.slice(0, limit);

  return (
    <section aria-labelledby="hot-list-title" className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 bg-foreground-950">
        <h3 id="hot-list-title" className="flex items-center gap-2 text-sm font-bold text-background-50">
          <i className="ri-fire-fill text-accent-400" aria-hidden="true" />
          {title}
        </h3>
        <span className="text-xs text-background-300">按热度排序</span>
      </div>
      <ol className="divide-y divide-background-200">
        {list.map((post, idx) => (
          <li key={post.id}>
            <Link
              to={`/post/${post.slug}`}
              className="flex items-start gap-3 px-4 py-3 hover:bg-background-100 transition-colors group"
            >
              <span
                className={`shrink-0 w-6 h-6 flex items-center justify-center rounded-md text-xs font-bold ${
                  idx < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                }`}
              >
                {idx + 1}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm leading-snug text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {post.title}
                </span>
                <span className="mt-1 flex items-center gap-2 text-xs text-foreground-400">
                  <span>{categoryNameOf(post.categorySlug)}</span>
                  <span>·</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-primary-400" aria-hidden="true" />
                    {post.heat}
                  </span>
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}